import { __awaiter, __generator } from "tslib";
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { applyOfficeIdentity, getRequestIdFromResponse, httpPatch, } from '@office-start/xhr-service';
import * as Cookies from 'es-cookie';
export function updateUserSetting(_a) {
    var userPinningStatus = _a.userPinningStatus, userStorageOptions = _a.userStorageOptions;
    return __awaiter(this, void 0, void 0, function () {
        var url, identity, requestConfig, csrfToken, response, errorMessage, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    url = userStorageOptions.officeHomeApiRoot + '/api/copilot/userSetting';
                    return [4 /*yield*/, userStorageOptions.getIdentity()];
                case 1:
                    identity = _b.sent();
                    if (userStorageOptions.jwtAuthEnabled && identity.isMsa) {
                        throw new Error('Unauthorized to update Copilot User Setting');
                    }
                    requestConfig = {
                        method: "PATCH" /* HttpRequestMethod.Patch */,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    };
                    if (!userStorageOptions.inMockMode &&
                        !userStorageOptions.jwtAuthEnabled) {
                        csrfToken = Cookies.get('AjaxSessionKey');
                        if (csrfToken) {
                            requestConfig.headers['AjaxSessionKey'] = csrfToken;
                        }
                        else {
                            logErrorEvent(KnownInstrumentationEvents.CsrfTokenError);
                            throw new Error('CSRF token missing');
                        }
                    }
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, userStorageOptions.inMockMode, userStorageOptions.workload, userStorageOptions.getIdentity)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, httpPatch(KnownInstrumentationEvents.CopilotUserSettingPatchRequest, "Copilot_User_Setting_Patch" /* KnownRequestInstrumentationEvents.CopilotUserSettingPatchRequest */, url, { userPinningStatus: userPinningStatus }, requestConfig, userStorageOptions.jwtAuthEnabled, userStorageOptions.getAccessToken, userStorageOptions.officeHomeApiRoot, userStorageOptions.correlationId, 'OfficeHome', {
                            populateRequestEvent: function (response, params) {
                                params["RequestId" /* InstrumentationParam.RequestId */] =
                                    getRequestIdFromResponse(response) || '';
                            },
                        })];
                case 3:
                    response = _b.sent();
                    if (!response || !response.ok) {
                        errorMessage = (response === null || response === void 0 ? void 0 : response.statusText) || 'API error';
                        throw new Error("Patch request failed: ".concat(errorMessage));
                    }
                    return [2 /*return*/, response.statusText];
                case 4:
                    error_1 = _b.sent();
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=patchUserSetting.js.map